export const ACTIONS = {
  ENABLE_MESSAGE: 'rightDrawerGroupMessage/enable',
  SET_ENFORCE_FOCUS: 'rightDrawerGroupMessage/set_enforce_focus',
};

export const enableRightDrawerGroupMessage = value => dispatch => {
  dispatch({ type: ACTIONS.ENABLE_MESSAGE, ...value });
  if (window.innerWidth >= 1024) {
    document.querySelector(
      '.right-drawer.drawer-message > .drawer-md-up',
    ).style.display = 'block';
  }
};
export const setEnforceFocus = enforceFocus => ({
  type: ACTIONS.SET_ENFORCE_FOCUS,
  payload: { enforceFocus },
});
